import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import useLabelsCore from "../../src/modules/core/labels";
import moment from "moment";

import CallIcon from "@material-ui/icons/Call";
import EmailIcon from "@material-ui/icons/Email";
import { checkAppVersion } from "../../src/modules/core/actions";
import logo from "../../src/assets/rehlati-logo.svg";

const ContactUs = () => {
  const labelsCore = useLabelsCore();
  const dispatch = useDispatch();

  const locale = useSelector((state) => state.core.locale);
  const contactInfo = useSelector(
    ({ core }) => core?.appVersion?.settings || {}
  );

  const getContacts = () => {
    let obj = {
      lang: locale,
      os: "web",
    };

    dispatch(checkAppVersion(obj));
  };

  const [startDay, setStartDay] = useState();
  const [endDay, setEndDay] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [supprtEmail, setSupprtEmail] = useState();
  const [supportPhone, setSupportPhone] = useState();

  useEffect(() => {
    getContacts();
  }, []);

  useEffect(() => {
    const start = moment().weekday(parseInt(contactInfo.working_start_day));
    const end = moment().weekday(parseInt(contactInfo.working_end_day));

    let seconds = "";
    let timeZone = "";
    if (contactInfo.working_start_hour.split(":")[2].includes("+")) {
      seconds = contactInfo.working_start_hour.split(":")[2].split("+")[0];
      timeZone =
        "+" + contactInfo.working_start_hour.split(":")[2].split("+")[1];
    } else if (contactInfo.working_start_hour.split(":")[2].includes("-")) {
      seconds = contactInfo.working_start_hour.split(":")[2].split("-")[0];
      timeZone =
        "-" + contactInfo.working_start_hour.split(":")[2].split("-")[1];
    }

    const startDateData = {
      hours: contactInfo.working_start_hour.split(":")[0],
      minutes: contactInfo.working_start_hour.split(":")[1],
      seconds: seconds,
      timeZone: timeZone,
    };

    if (contactInfo.working_end_hour.split(":")[2].includes("+")) {
      seconds = contactInfo.working_end_hour.split(":")[2].split("+")[0];
      timeZone = "+" + contactInfo.working_end_hour.split(":")[2].split("+")[1];
    } else if (contactInfo.working_end_hour.split(":")[2].includes("-")) {
      seconds = contactInfo.working_end_hour.split(":")[2].split("-")[0];
      timeZone = "-" + contactInfo.working_end_hour.split(":")[2].split("-")[1];
    }

    const endDateData = {
      hours: contactInfo.working_end_hour.split(":")[0],
      minutes: contactInfo.working_end_hour.split(":")[1],
      seconds: seconds,
      timeZone: timeZone,
    };

    const startDate = moment()
      .utc()
      .set({
        hours: startDateData.hours,
        minutes: startDateData.minutes,
        seconds: startDateData.seconds,
      });

    const endDate = moment()
      .utc()
      .set({
        hours: endDateData.hours,
        minutes: endDateData.minutes,
        seconds: endDateData.seconds,
      });

    setStartDay(start.format("dddd").toString());
    setEndDay(end.format("dddd").toString());
    setStartDate(
      startDate
        .utcOffset("+0400")
        .format("HH:mm")
        .toString()
    );
    setEndDate(
      endDate
        .utcOffset("+0400")
        .format("HH:mm")
        .toString()
    );
    setSupportPhone(contactInfo.support_phone);
    setSupprtEmail(contactInfo.support_email);
  }, [contactInfo]);

  return (
    <Grid
      container
      spacing={10}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item>
        <img src={logo} alt="rehlati-logo" />
      </Grid>

      <Grid item>
        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <Typography variant="h4" color="secondary" display="inline" noWrap>
              {labelsCore.customerCare}
            </Typography>
          </Grid>
          <Grid item>
            <Grid
              container
              spacing={2}
              direction="row"
              alignContent="center"
              justifyContent="center"
            >
              <Grid item>
                <CallIcon color="primary" />
              </Grid>
              <Grid item>
                <Typography color="secondary" display="inline" noWrap>
                  {supportPhone}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              spacing={2}
              direction="row"
              alignContent="center"
              justifyContent="center"
            >
              <Grid item>
                <EmailIcon color="primary" />
              </Grid>
              <Grid item>
                <Typography color="secondary" display="inline" noWrap>
                  {supprtEmail}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item>
        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <Typography variant="h4" color="secondary" display="inline" noWrap>
              {labelsCore.workingHours}
            </Typography>
          </Grid>

          <Grid item>
            <Typography color="secondary" display="inline" noWrap>
              {startDate} to {endDate} (UTC +04:00)
            </Typography>
          </Grid>

          <Grid item>
            <Typography color="secondary" display="inline" noWrap>
              {startDay} to {endDay}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default ContactUs;
